module.exports = __webpack_public_path__ + "components/rewards-header/static/background-4685e51ea024cbfd4bf162e2b77011c1.webp";